import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Card,
  Form,
  Statistic,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Layout,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Modal,
  Tooltip,
  List,
} from "antd";
import {
  PlusOutlined,
  FolderOpenOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import dayjs from "dayjs";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";

const { TextArea } = Input;
const { Content } = Layout;
const { Panel } = Collapse;

const InterestRateChart = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    interestRateChartTableSource,
    setInterestRateChartTableSource,
  } = props;
  const { Text, Title } = Typography;

  const handleChargeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = interestRateChartTableSource.filter(
          (item) => item.id !== key.id
        );
        setInterestRateChartTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From / To",
      dataIndex: "fromPeriodTo",
    },
    {
      title: "Amount Range",
      dataIndex: "amountRange",
    },
    {
      title: "Interest",
      dataIndex: "interest",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        interestRateChartTableSource.length >= 1 ? (
          <Tooltip title={`Incentives`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              // onClick={() => handleChargeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          {labelConfig.interestRateInfo}
        </Title>
      </Divider>
      <Table
        columns={columns}
        dataSource={interestRateChartTableSource}
        bordered
        pagination={{
          position: "bottomCentre",
          pageSize: "10",
        }}
      />
    </Form>
  );
};
export default InterestRateChart;
